export const ROBOT_SELECTED = 'Robot selected';
